const projectId = 'mr-website-fb6db';

export default function useFunctionsUrl() {
  //TODO: NEXT - this still isn't working when running the emulator locally
  // Explicit override if provided (e.g., VITE_FUNCTIONS_BASE_URL=http://127.0.0.1:5001/mr-website-fb6db/us-central1)
  const envBase = import.meta.env.VITE_FUNCTIONS_BASE_URL as string | undefined
  if (envBase) return envBase.replace(/\/$/, '')

  // const isLocal =
  //   window.location.hostname === 'localhost' ||
  //   window.location.hostname === '127.0.0.1' ||
  //   window.location.hostname === '[::1]'

  return `https://us-central1-${encodeURIComponent(projectId)}.cloudfunctions.net`;
  // Prefer 127.0.0.1 to avoid IPv6/localhost resolution quirks with the emulator
  // return isLocal
  //   ? `http://127.0.0.1:5001/${encodeURIComponent(projectId)}/us-central1`
  //   : `https://us-central1-${encodeURIComponent(projectId)}.cloudfunctions.net`
}